const frozenViewsBuilder = ({ rows, columns }) => [
  { state: 'frozen', ySplit: rows, xSplit: columns },
];

export default frozenViewsBuilder;
